import { render, staticRenderFns } from "./ssgoodsclass.vue?vue&type=template&id=79773b37&"
import script from "./ssgoodsclass.vue?vue&type=script&lang=js&"
export * from "./ssgoodsclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports